import React from "react";
import { Stack, IconButton, Tooltip } from "@mui/material";

const ActionButtons = ({ actions }) => {
  return (
    <Stack direction="row" spacing={1}>
      {actions.map((action, idx) => (
        <Tooltip key={idx} title={action.tooltip}>
          <IconButton
            color={action.color || "primary"}
            size={action.size || "medium"}
            onClick={action.onClick}
          >
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default ActionButtons;
